import type { WebSockets } from '@pushflow/types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { TableInfoType } from '../../../types'
import { trpc } from '../../../utils'
import { Scrollable } from '../../atoms'
import { PokerRoom } from '../../templates'
import {
  contentStyle,
  drawerContainer,
  handEntity,
  roomEntity,
  scrollableBlock,
} from './index.css'

export const TableMenuHandHistory = (props: {
  tableId: string
  userId: string
  valuesInBigBlinds: boolean
}) => {
  const {
    data: handHistory,
    // isLoading: isHistoryLoading,
    isFetched: isHistoryLoaded,
  } = trpc.table.getHandHistory.useQuery({
    tableId: props.tableId,
  })
  const { t } = useTranslation()
  const [snapshots, setSnapshots] = useState<
    {
      snapshot: {
        id: string
        createdAt: string
        handNumber: number
      }
      data: {
        info: TableInfoType
        table: WebSockets.TableStateDataType
        players: WebSockets.PlayerDataType[]
        pots: WebSockets.PotType[]
        winners: WebSockets.WinnerType[]
      }
    }[]
  >([])

  useEffect(() => {
    if (!handHistory) {
      return
    }
    const snapshotsParsed = handHistory.state.map((state) => {
      const { data, id, createdAt, handNumber } = state
      return {
        snapshot: {
          id,
          createdAt,
          handNumber,
        },
        data,
      }
    })
    // @ts-expect-error data.table: string vs Date
    setSnapshots(snapshotsParsed)
  }, [handHistory])

  return (
    <div className={drawerContainer}>
      <div className={contentStyle}>
        <Scrollable className={scrollableBlock}>
          {isHistoryLoaded && snapshots.length === 0
            ? t('modal.recentHands.label.noHistory')
            : snapshots.map((snapshotData) => {
                const userPlayer = snapshotData.data.players.find(
                  (player) => player.userId === props.userId,
                )
                const snapshotTime = new Date(snapshotData.snapshot.createdAt)
                return (
                  <div
                    key={snapshotData.snapshot.id}
                    className={handEntity}
                  >
                    <span>
                      {t('modal.recentHands.label.handEntity', {
                        round: snapshotData.snapshot.handNumber,
                        time: snapshotTime.toLocaleTimeString(),
                      })}
                    </span>
                    <div className={roomEntity}>
                      <PokerRoom
                        table={snapshotData.data.table}
                        players={snapshotData.data.players}
                        userSeat={userPlayer?.seat ?? null}
                        pots={snapshotData.data.pots}
                        valuesInBigBlinds={props.valuesInBigBlinds}
                        winners={snapshotData.data.winners}
                        modes={{
                          doubleBoard: snapshotData.data.info
                            .isDoubleBoardPossible
                            ? snapshotData.data.table.isDoubleBoardActive
                              ? 'active'
                              : 'inactive'
                            : null,
                          bombPot:
                            snapshotData.data.info.bombPotMin &&
                            snapshotData.data.info.bombPotMax &&
                            snapshotData.data.info.bombPotFrequency &&
                            snapshotData.data.info
                              .bombPotActivateDoubleBoard !== null
                              ? {
                                  min: snapshotData.data.info.bombPotMin,
                                  max: snapshotData.data.info.bombPotMax,
                                  frequency:
                                    snapshotData.data.info.bombPotFrequency,
                                  activateDoubleBoard:
                                    snapshotData.data.info
                                      .bombPotActivateDoubleBoard,
                                  state:
                                    snapshotData.data.info.bombPotFrequency <=
                                      1 ||
                                    snapshotData.data.table
                                      .lastBombPotTriggeredHandNumber ===
                                      null ||
                                    snapshotData.data.table.handNumber ===
                                      snapshotData.data.table
                                        .lastBombPotTriggeredHandNumber +
                                        snapshotData.data.info.bombPotFrequency
                                      ? 'active'
                                      : 'inactive',
                                }
                              : null,
                        }}
                        tableInfo={snapshotData.data.info}
                        userId={props.userId}
                        isSnapshot={true}
                        renderUserPlayer={true}
                      />
                    </div>
                  </div>
                )
              })}
        </Scrollable>
      </div>
    </div>
  )
}
